import { createContext, useContext } from 'react';

export interface SliderContextValues {
  min: number;
  max: number;
  value: number;
  scheme?: 'dark' | 'light';
  valToString: (val: number) => string;
  onChange: (val: number) => void;
}

export const SliderContext = createContext<SliderContextValues>({
  min: 0,
  max: 0,
  value: 0,
  scheme: 'dark',
  valToString: String,
  onChange: () => {},
});

export const useSliderContext = () => {
  const context = useContext(SliderContext);
  if (context === undefined) {
    throw new Error(
      'useSliderContext must be used within a SliderContext.Provider'
    );
  }
  return context;
};
